

export default function getComponentProps(data: any) {
  const { column } = data;
  const { componentProps } = column;
  return componentProps ? typeof componentProps === 'function' ? componentProps(data) : componentProps : {};
}